export default __webpack_public_path__ + "static/assets/fe8c4645b4169a39a83817aefdac62ca.png";